module.exports = __webpack_public_path__ + "img/left-arrow4.90f7469b.svg";